<template>
  <div>
    <div class="mb-base">
      <h2>{{$t('Dashboard')}}</h2>
    </div>
    <div class="flex flex-wrap items-center gap-2 mb-base rounded-xl border border-solid border-grey-light bg-white md:py-6 p-4">
      <table-filter icon="UserIcon" filterLabel="Merchant" :filters="filters" :statusFilters="merchants" @changeFilter="changeFilter" @filterValue="filterValue = $event"/>
      <filter-date modalPosition="left-0" :filterDateModal="filterDateModal" :startDate="startDate" :endDate="endDate" @filterDateModal="filterDateModal = $event" @startDate="startDate = $event" @endDate="endDate = $event" @loadTransactions="loadStatistics"/>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-for="card in cards" :key="card.key">
        <statistics-card-line
          hideChart
          :dataLoading="statisticsLoading"
          :icon="card.icon"
          :color="card.color"
          :statistic="statistics[card.key] || 0"
          :statisticTitle="$t(card.title)"
        ></statistics-card-line>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import {sendFulfillmentRequest} from '../../http/axios/requestHelper.js'
import TableFilter from '../merchant/components/TableFilter.vue'
import FilterDate from '../finance/components/FilterDate.vue'
import common from '@/assets/utils/common'

export default {
  data () {
    const today = new Date()
    return {
      cards: [
        {key: 'stock_requests', title: 'Stock Requests', icon: 'ArchiveIcon', color: 'primary'},
        {key: 'stock_recalls', title: 'Stock Recalls', icon: 'RotateCcwIcon', color: 'warning'},
        {key: 'inbound_orders', title: 'Inbound Orders', icon: 'LogInIcon', color: 'success'},
        {key: 'outbound_orders', title: 'Outbound Orders', icon: 'LogOutIcon', color: 'danger'},
        {key: 'used_storage_units', title: 'Used Storage Units', icon: 'GridIcon', color: 'dark'}
      ],
      statistics: {},
      statisticsLoading: false,
      merchants: [],
      filters: [],
      filterValue: '',
      filterDateModal: false,
      startDate: new Date(today.getFullYear(), today.getMonth(), 1),
      endDate: today
    }
  },
  methods: {
    formatDate (date) {
      const value = new Date(date)
      return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
    },
    loadStatistics () {
      const from = this.startDate ? this.formatDate(this.startDate) : ''
      const to = this.endDate ? this.formatDate(this.endDate) : ''
      const query = `?from=${from}&to=${to}&merchant=${this.filters}`
      this.statisticsLoading = true
      sendFulfillmentRequest(false, false, this, `api/v1/fc/fc-operations-supervisor/dashboard${query}`, 'get', null, true,
        (response) => {
          this.statistics = response.data
          this.statisticsLoading = false
        },
        (error) => {
          this.statisticsLoading = false
          common.notifyResponseError(this, error)
        }
      )
    },
    changeFilter () {
      this.filters = this.filterValue === 'all' ? [] : [this.filterValue]
      this.loadStatistics()
    },
    loadMerchants () {
      sendFulfillmentRequest(false, false, this, 'api/v1/fc/merchants/?limit=100&status=active', 'get', null, true,
        (response) => {
          this.merchants = response.data.results.map(merchant => ({
            ...merchant,
            value: merchant.id
          }))
          this.merchants.unshift({
            name: 'All',
            value: 'all'
          })
        })
    }
  },
  components: {
    StatisticsCardLine,
    TableFilter,
    FilterDate
  },
  created () {
    this.loadStatistics()
    this.loadMerchants()
  }
}
</script>
